export default {
    dashboard: 'Dashboard',
    athletes: {
        title: 'Clients',
        all: 'View all clients',
        statistics: 'Client statistics',
        new: 'Create new client',
        quickAdd: 'Quick client creation'
    },
    foods: 'Food list',
    dietPlans: {
        title: 'Diet plans',
        all: 'View all plans',
        templates: 'Meal templates',
        statistics: 'Statistics',
        printTemplates: 'Print templates',
        noteTemplates: 'Note templates',
        recipes: 'Recipes'
    },
    scienceTools: 'Scientific tools',
    chat: 'Chat',
    calendar: 'Calendar',
    menu: 'Menu',
    marketplace: 'vresdiatrofologo',
    pathisis: 'Pathisis',
    noResults: 'No results found',
    aCloud: 'aCloud',
    markAsRead: 'Mark as read',
    account: 'Account',
    logout: 'Logout',
    settings: {
        title: 'Settings',
        mobileFeed: {
            label: 'Mobile Feed Notifications',
            description: 'Enable/disable notification badges for new client meal entries.'
        },
        aiPrompts: {
            label: 'AI Prompts',
            description: 'Show or hide AI prompts.'
        },
        chatBot: {
            label: 'Chat Bot',
            description: 'Show or hide the chat bot.'
        },
        prolipsisWidget: {
            label: 'Prolipsis Widget',
            description: 'Show or hide the Prolipsis widget.'
        },
        clientFileUploads: {
            label: 'Files from clients',
            description: 'Your clients can send you photos and PDFs from the app. Turning this off stops every client from sending files.'
        }
    },
    news: {
        title: 'Notifications',
        filterAll: 'All',
        filterMeals: 'Meal logs',
        filterUpdates: 'Updates',
        newMealLog: 'New meal log from',
        update: 'Update',
        today: 'Today',
        yesterday: 'Yesterday',
        noItems: "You're all caught up",
        noItemsText: 'New client meal logs and athlisis updates will show up here.',
        noNews: 'No updates yet',
        noNewsText: 'News and announcements from athlisis will show up here.',
        noMeals: 'No new entries',
        noMealsText: 'What your clients log in the app will show up here.',
        manageNotifications: 'Manage notifications'
    }

}
